import { useEffect, useCallback } from 'react';

const ChecklistListeners = ({ eventEmitter, applyStoreAction }) => {
    const checklistCreated = useCallback(checklist => {
        applyStoreAction({
            type: 'CHECKLIST_ADD_SOCKET',
            payload: {
                taskId: checklist.task_id,
                checklist
            }
        });
    }, [applyStoreAction]);

    const checklistEdited = useCallback(checklist => {
        applyStoreAction({
            type: 'CHECKLIST_UPDATE_SOCKET',
            payload: {
                checklistId: checklist.id,
                checklist
            }
        });
    }, [applyStoreAction]);

    const checklistRemoved = useCallback(({ id }) => {
        applyStoreAction({
            type: 'CHECKLIST_REMOVE_SOCKET',
            payload: {
                checklistId: id
            }
        });
    }, [applyStoreAction]);

    const checklistItemsCreated = useCallback(({ items }) => {
        applyStoreAction({
            type: 'CHECKLIST_ITEMS_ADD_SOCKET',
            payload: {
                checklistId: items[0]?.checklist_id,
                checklistItems: items
            }
        });
    }, [applyStoreAction]);

    const checklistItemEdited = useCallback(checklistItem => {
        applyStoreAction({
            type: 'CHECKLIST_ITEM_UPDATE_SOCKET',
            payload: {
                checklistId: checklistItem.checklist_id,
                checklistItemId: checklistItem.id,
                checklistItem
            }
        });
    }, [applyStoreAction]);

    const checklistItemRemoved = useCallback(checklistItem => {
        applyStoreAction({
            type: 'CHECKLIST_ITEM_REMOVE_SOCKET',
            payload: {
                checklistId: checklistItem.checklist_id,
                checklistItemId: checklistItem.id
            }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('checklist_created', checklistCreated);
        eventEmitter.on('checklist_edited', checklistEdited);
        eventEmitter.on('checklist_removed', checklistRemoved);
        eventEmitter.on('checklist_item_created', checklistItemsCreated);
        eventEmitter.on('checklist_item_edited', checklistItemEdited);
        eventEmitter.on('checklist_item_removed', checklistItemRemoved);

        return () => {
            eventEmitter.off('checklist_created', checklistCreated);
            eventEmitter.off('checklist_edited', checklistEdited);
            eventEmitter.off('checklist_removed', checklistRemoved);
            eventEmitter.off('checklist_item_created', checklistItemsCreated);
            eventEmitter.off('checklist_item_edited', checklistItemEdited);
            eventEmitter.off('checklist_item_removed', checklistItemRemoved);
        };
    };

    useEffect(listen, [eventEmitter, checklistCreated, checklistEdited, checklistRemoved]);

    return null;
}

export default ChecklistListeners;
